import { useContext } from "react";
import stylesArabic from "./FundamentalPackage.module.css";
import styles from "./FundamentalPackageEnglish.module.css";
import { CiCircleCheck } from "react-icons/ci";
import { HomePageContext } from "../../store/HomePageContext.jsx";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext.jsx";
import { useNavigate } from "react-router-dom";
import imgArab from "./ImageArab.webp";
import imgEng from "./ImageEng.webp";
import riyals from "./riyals.svg";

function FundamentalPackage() {
  const { homeScreenDetails, loading, error } = useContext(HomePageContext);
  const { direction, language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const stylesSelected = language === "ar" ? stylesArabic : styles;

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  // Extract the relevant data from homeScreenDetailsSec7
  const sectionData = homeScreenDetails?.homeScreenDetailsSec7 || {};
  const title =
    sectionData?.title ||
    "Subscribe To The Full Filmmaking Fundamentals Package";

  // Use the imported images based on direction
  const imageUrl = direction === "rtl" ? imgArab : imgEng;

  const categories = sectionData?.category || [];
  const subscribeText = direction === "rtl" ? "اشترك الآن" : "Subscribe";
  const price = homeScreenDetails?.priceDetail?.price || "2,200 SAR";

  const handleSubscribe = () => {
    navigate("/home/R2/bundle");
  };

  const convertToArabicNumerals = (num) => {
    const arabicNumerals = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
    return num
      .toString()
      .split("")
      .map((digit) =>
        digit === "," ? "،" : arabicNumerals[parseInt(digit)] || digit
      )
      .join("");
  };

  const formatPrice = (price, isArabic) => {
    return isArabic ? convertToArabicNumerals(price) : price;
  };

  return (
    <div className="parentfundamental">
      <div className={stylesSelected.Fundamental}>
        <div className={stylesSelected.secondcontainer}>
          <div className={stylesSelected.content}>
            <p style={{ maxWidth: "100%", fontSize: "36px" }}>{title}</p>
            <div className={stylesSelected.imgcontainer}>
              <img
                src={imageUrl}
                alt="Filmmaking Package"
                className={styles.imgcontainer}
              />
            </div>
          </div>
          <div className={stylesSelected.subscribe}>
            <div className={stylesSelected.ctn}>
              {categories.map((item, index) => (
                <div key={index} className={stylesSelected.item}>
                  <CiCircleCheck className={stylesSelected.checkico} />
                  <p>{item}</p>
                  {/* <p style={{ fontSize: "36px" }}>{item}</p> */}
                </div>
              ))}
              <div
                style={{ alignItems: "center" }}
                className={stylesSelected.item}
              >
                <button
                  style={{ position: "relative", top: "10px" }}
                  onClick={handleSubscribe}
                  className={stylesSelected.checkicobuttun}
                >
                  {subscribeText}
                </button>
                <p
                  style={{ position: "relative", top: "-10px" }}
                  className={styles.lines}
                >
                  &nbsp;&nbsp;
                  <div
                    className={styles.staticone}
                    style={{
                      position: "relative",
                      top: direction === "rtl" ? "-20px" : "-8px",
                    }}
                  >
                    <b className={styles.lines1}>
                      <span className={styles.strikethrough}>
                        <span
                          style={{
                            fontSize: "25px",
                            position: "relative",
                            top: "0px",
                          }}
                        >
                          &nbsp;{direction === "rtl" ? "٦،٤٠٠" : "6,400"}
                        </span>
                        <img
                          style={{ position: "relative", top: "5px" }}
                          src={riyals}
                          alt="SAR"
                          className={styles.riyalsIcon}
                        />
                      </span>
                      &nbsp;
                    </b>
                    &nbsp;&nbsp;
                    <b className={styles.price}>
                      {direction === "rtl" ? "٢،٢٠٠" : "2,200"}
                      <img
                        src={riyals}
                        alt="SAR"
                        className={styles.riyalsIcon}
                      />
                    </b>
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FundamentalPackage;
